import { Button, Divider, Stack } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { selectBillingAccountAgreements } from '@sophocles/features/billing/slice';
import { AgreementCard, AgreementDialog } from '@sophocles/views/billing/components';

function BillingAccountAgreementTab({ accountId, canEdit }) {
  const { t } = useTranslation();
  const [showOlderAgreements, setShowOlderAgreements] = useState(false);
  const [isAgreementDialogOpen, setIsAgreementDialogOpen] = useState(false);
  const [selectedAgreementId, setSelectedAgreementId] = useState(null);

  const agreements = useSelector(selectBillingAccountAgreements(accountId));

  const activeAgreement = agreements.length > 0 ? agreements[0] : null;

  return (
    <>
      <AgreementCard
        agreement={activeAgreement}
        sx={{ mb: 2 }}
        onEdit={
          canEdit
            ? id => {
                setSelectedAgreementId(id);
                setIsAgreementDialogOpen(true);
              }
            : null
        }
      />
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Button onClick={() => setShowOlderAgreements(!showOlderAgreements)}>
          {showOlderAgreements ? 'Hide' : 'Show'} Older Agreements
        </Button>
        <Button
          disabled={isAgreementDialogOpen}
          onClick={() => {
            setSelectedAgreementId(null);
            setIsAgreementDialogOpen(true);
          }}
        >
          {t('settings.addNewAgreement', 'Add New Agreement')}
        </Button>
      </Stack>
      {showOlderAgreements &&
        agreements
          .filter(agreement => !agreement.is_active)
          .map(agreement => {
            return <AgreementCard key={agreement.id} agreement={agreement} sx={{ mb: 3 }} />;
          })}
      <Divider sx={{ mb: 4 }} />
      <AgreementDialog
        id={selectedAgreementId}
        accountId={accountId}
        open={isAgreementDialogOpen}
        onClose={() => {
          setIsAgreementDialogOpen(!isAgreementDialogOpen);
        }}
      />
    </>
  );
}

export default BillingAccountAgreementTab;
